export default __webpack_public_path__ + "bcca71e5fce81a5afa4a691f0e752c5a.png";